import gql from 'graphql-tag';

const AskChefQuery = {
  getFaqsAll: gql`
    query getFaqsAll(
      $page: Int
      $search: String
      $setLimit: Int
      $authorIdFilter: Float
      $mePeopleIdFilter: Boolean
    ) {
      getFaqsAll(
        page: $page
        search: $search
        setLimit: $setLimit
        authorIdFilter: $authorIdFilter
        mePeopleIdFilter: $mePeopleIdFilter
        imageSizeFilter: "80"
      ) {
        totalCount
        faqItems {
          id
          peopleItem {
            id
            fio
            date
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
          answerUserItem {
            fio
          }
          date
          question

          answer
          answer_date
          # блок сообщений к вопросу, включая ответ шеф повара и комментарии пиплов к этому ответу
          faqMessagesItems {
            id
            message
            date
            people_id # if people id то коммент к ответу шеф повара и фио с лого брать из peopleItem
            # if people id null то пишет шеф повар userItem
            userItem {
              id
              fio
              attachmentsItem {
                cacheItem {
                  filePath
                }
              }
            }
          }
        }
      }
    }
  `,
  addFaqItem: gql`
    mutation addFaqItem($email: String!, $peopleId: Int!, $question: String!) {
      addFaqItem(question: $question, peopleId: $peopleId, email: $email) {
        totalCount
      }
    }
  `
};
export default AskChefQuery;
